import { render, staticRenderFns } from "./AccidentIntakeWorkInformationForm.vue?vue&type=template&id=7ecae0fe"
import script from "./AccidentIntakeWorkInformationForm.vue?vue&type=script&lang=js"
export * from "./AccidentIntakeWorkInformationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports